export default function TableResponse({ data }) {
  if (!data?.columns || !data?.rows) return null;

  const getRowColor = (index) => {
    return index % 2 === 0
      ? "bg-white"
      : "bg-gradient-to-r from-indigo-50 to-blue-50";
  };

  const getHeaderBg = () => {
    return "bg-gradient-to-r from-indigo-600 via-purple-600 to-blue-600";
  };

  return (
    <div className="overflow-x-auto rounded-xl border-2 border-indigo-300 mt-2" style={{
      boxShadow: "0 0 20px rgba(79, 70, 229, 0.2), 0 8px 16px rgba(0, 0, 0, 0.08)"
    }}>
      <table className="min-w-full text-sm">
        <thead>
          <tr className={`${getHeaderBg()} text-white`}>
            {data.columns.map((col) => (
              <th
                key={col}
                className="px-5 py-3 text-left text-xs font-bold whitespace-nowrap transition-all duration-300 hover:bg-indigo-700 cursor-default"
                style={{
                  textTransform: "uppercase",
                  letterSpacing: "0.5px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
                }}
              >
                ▸ {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.rows.map((row, i) => {
            const rowColor = getRowColor(i);
            return (
              <tr
                key={i}
                className={`${rowColor} border-b border-indigo-100 hover:shadow-md hover:bg-indigo-100 transition-all duration-200`}
                style={{
                  borderLeft: i % 3 === 0 ? "4px solid #4F46E5" : i % 3 === 1 ? "4px solid #A855F7" : "4px solid #06B6D4"
                }}
              >
                {data.columns.map((col, colIndex) => (
                  <td
                    key={col}
                    className="px-5 py-3 text-xs whitespace-nowrap font-semibold transition-colors duration-200"
                    style={{
                      color: ["#111827", "#4F46E5", "#0891B2", "#A855F7", "#009F52", "#F97316"][colIndex % 6]
                    }}
                  >
                    {row[col]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
      {data.footer && (
        <div
          className="px-5 py-3 text-xs font-semibold border-t-2 border-indigo-200"
          style={{
            background: "linear-gradient(90deg, #F0F4FF 0%, #F3E8FF 100%)",
            color: "#4F46E5"
          }}
        >
          📊 {data.footer}
        </div>
      )}
    </div>
  );
}